<div class="rfq-product-info__wrapper">
  <form [formGroup]="form">
    <div class="row">
      <div class="col-md-6">
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label for="">Shipment Value</label>
              <input
                type="number"
                class="lum-input"
                min="0"
                formControlName="shipment_value"
              />
            </div>
          </div>
          <div class="col-md-12">
            <div class="form-group">
              <label for="">Efficiency Score</label>
              <mat-select class="lum-select" formControlName="efficiency_score">
                <mat-option value="0">--- Select efficiency score ---</mat-option>
                <mat-option
                  *ngFor="let setting of settings.labor_costs"
                  [value]="setting.score"
                >
                  {{ setting.score }} => {{ setting.cost | currency: '' }}
                </mat-option>
              </mat-select>
            </div>
          </div>
          <div class="col-md-12">
            <div class="form-group">
              <label for="">Package Cost ($)</label>
              <input
                type="numeric"
                class="lum-input"
                min="0"
                formControlName="package_cost"
              />
            </div>
          </div>
          <div class="col-md-12">
            <div class="form-group">
              <label for="">Set Default Shipping</label>
              <mat-select class="lum-select" formControlName="default_shipping">
                <mat-option value="0">--- Select default shipping ---</mat-option>
                <mat-option
                  *ngFor="let carrier of shippingCarriers"
                  [value]="carrier.id"
                >
                  {{ carrier.carrier_name }}</mat-option
                >
              </mat-select>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="row">
          <div class="col-md-12">
            <div class="font-semi-bold mb-2">Product Dimension</div>
            <div class="form-group">
              <div class="flex align-center gap-4">
                <label class="inline-label">Weight</label>
                <div formArrayName="productWeights">
                  <ng-container
                    *ngFor="
                      let dimension of productWeightsControl.controls;
                      let idx = index
                    "
                  >
                    <div class="flex gap-2 mb-1" [formGroupName]="idx">
                      <input
                        type="number"
                        class="lum-input grow-0 w-p40"
                        min="0"
                        formControlName="wv"
                      />
                      <mat-select
                        class="lum-select grow-0 w-p40"
                        formControlName="mu"
                      >
                        <mat-option
                          *ngFor="let unit of weightUnits"
                          [value]="unit"
                          >{{ unit }}</mat-option
                        >
                      </mat-select>
                      <div class="grow-0">
                        <ng-container *ngIf="idx === 0; else removeWeight">
                          <button
                            class="lum-button w-20"
                            mat-icon-button
                            (click)="onAddWeight('productWeights')"
                          >
                            <lum-ui-icon
                              icon="add-1"
                              [width]="16"
                              [height]="16"
                              color="#ffffff"
                            ></lum-ui-icon>
                          </button>
                        </ng-container>
                        <ng-template #removeWeight>
                          <button
                            class="lum-button lum-button--secondary w-20"
                            mat-icon-button
                            (click)="onRemoveWeight('productWeights', idx)"
                          >
                            <lum-ui-icon
                              icon="minus-circle"
                              [width]="16"
                              [height]="16"
                              color="#3a47af"
                            ></lum-ui-icon>
                          </button>
                        </ng-template>
                      </div>
                    </div>
                  </ng-container>
                </div>
              </div>
            </div>
            <div class="form-group">
              <div class="flex align-center gap-4">
                <label class="inline-label">Dimensions (in)</label>
                <div class="flex gap-2">
                  <input
                    type="number"
                    class="lum-input"
                    formControlName="product_length"
                    min="0"
                    placeholder="Length"
                  />
                  <input
                    type="number"
                    class="lum-input"
                    formControlName="product_width"
                    min="0"
                    placeholder="Width"
                  />
                  <input
                    type="number"
                    class="lum-input"
                    formControlName="product_height"
                    min="0"
                    placeholder="Height"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-12">
            <div class="font-semi-bold mb-2">Shipping Dimension</div>
            <div class="form-group">
              <div class="flex align-center gap-4">
                <label class="inline-label">Weight</label>
                <div formArrayName="shippingWeights">
                  <ng-container
                    *ngFor="
                      let dimension of shippingWeightsControl.controls;
                      let idx = index
                    "
                  >
                    <div class="flex gap-2 mb-1" [formGroupName]="idx">
                      <input
                        type="number"
                        class="lum-input grow-0 w-p40"
                        min="0"
                        formControlName="wv"
                      />
                      <mat-select
                        class="lum-select grow-0 w-p40"
                        formControlName="mu"
                      >
                        <mat-option
                          *ngFor="let unit of weightUnits"
                          [value]="unit"
                          >{{ unit }}</mat-option
                        >
                      </mat-select>
                      <div class="grow-0">
                        <ng-container *ngIf="idx === 0; else removeWeight">
                          <button
                            class="lum-button w-20"
                            mat-icon-button
                            (click)="onAddWeight('shippingWeights')"
                          >
                            <lum-ui-icon
                              icon="add-1"
                              [width]="16"
                              [height]="16"
                              color="#ffffff"
                            ></lum-ui-icon>
                          </button>
                        </ng-container>
                        <ng-template #removeWeight>
                          <button
                            class="lum-button lum-button--secondary w-20"
                            mat-icon-button
                            (click)="onRemoveWeight('shippingWeights', idx)"
                          >
                            <lum-ui-icon
                              icon="minus-circle"
                              [width]="16"
                              [height]="16"
                              color="#3a47af"
                            ></lum-ui-icon>
                          </button>
                        </ng-template>
                      </div>
                    </div>
                  </ng-container>
                </div>
              </div>
            </div>
            <div class="form-group">
              <div class="flex align-center gap-4">
                <label class="inline-label">Dimensions (in)</label>
                <div class="flex gap-2">
                  <input
                    type="number"
                    class="lum-input"
                    formControlName="product_length"
                    min="0"
                    placeholder="Length"
                  />
                  <input
                    type="number"
                    class="lum-input"
                    formControlName="product_width"
                    min="0"
                    placeholder="Width"
                  />
                  <input
                    type="number"
                    class="lum-input"
                    formControlName="product_height"
                    min="0"
                    placeholder="Height"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-12">
            <div class="font-semi-bold mb-2">Box Dimension</div>
            <div class="form-group">
              <div class="flex align-center gap-4">
                <label class="inline-label">Weight</label>
                <div formArrayName="boxWeights">
                  <ng-container
                    *ngFor="
                      let dimension of boxWeightsControl.controls;
                      let idx = index
                    "
                  >
                    <div class="flex gap-2 mb-1" [formGroupName]="idx">
                      <input
                        type="number"
                        class="lum-input grow-0 w-p40"
                        min="0"
                        formControlName="wv"
                      />
                      <mat-select
                        class="lum-select grow-0 w-p40"
                        formControlName="mu"
                      >
                        <mat-option
                          *ngFor="let unit of weightUnits"
                          [value]="unit"
                          >{{ unit }}</mat-option
                        >
                      </mat-select>
                      <div class="grow-0">
                        <ng-container *ngIf="idx === 0; else removeWeight">
                          <button
                            class="lum-button w-20"
                            mat-icon-button
                            (click)="onAddWeight('boxWeights')"
                          >
                            <lum-ui-icon
                              icon="add-1"
                              [width]="16"
                              [height]="16"
                              color="#ffffff"
                            ></lum-ui-icon>
                          </button>
                        </ng-container>
                        <ng-template #removeWeight>
                          <button
                            class="lum-button lum-button--secondary w-20"
                            mat-icon-button
                            (click)="onRemoveWeight('boxWeights', idx)"
                          >
                            <lum-ui-icon
                              icon="minus-circle"
                              [width]="16"
                              [height]="16"
                              color="#3a47af"
                            ></lum-ui-icon>
                          </button>
                        </ng-template>
                      </div>
                    </div>
                  </ng-container>
                </div>
              </div>
            </div>
            <div class="form-group">
              <div class="flex align-center gap-4">
                <label class="inline-label">Dimensions (in)</label>
                <div class="flex gap-2">
                  <input
                    type="number"
                    class="lum-input"
                    formControlName="product_length"
                    min="0"
                    placeholder="Length"
                  />
                  <input
                    type="number"
                    class="lum-input"
                    formControlName="product_width"
                    min="0"
                    placeholder="Width"
                  />
                  <input
                    type="number"
                    class="lum-input"
                    formControlName="product_height"
                    min="0"
                    placeholder="Height"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-12">
            <div class="font-semi-bold mb-2">Carton Dimension</div>
            <div class="form-group">
              <div class="flex align-center gap-4">
                <label class="inline-label">Weight</label>
                <div formArrayName="cartonWeights">
                  <ng-container
                    *ngFor="
                      let dimension of cartonWeightsControl.controls;
                      let idx = index
                    "
                  >
                    <div class="flex gap-2 mb-1" [formGroupName]="idx">
                      <input
                        type="number"
                        class="lum-input grow-0 w-p40"
                        min="0"
                        formControlName="wv"
                      />
                      <mat-select
                        class="lum-select grow-0 w-p40"
                        formControlName="mu"
                      >
                        <mat-option
                          *ngFor="let unit of weightUnits"
                          [value]="unit"
                          >{{ unit }}</mat-option
                        >
                      </mat-select>
                      <div class="grow-0">
                        <ng-container *ngIf="idx === 0; else removeWeight">
                          <button
                            class="lum-button w-20"
                            mat-icon-button
                            (click)="onAddWeight('cartonWeights')"
                          >
                            <lum-ui-icon
                              icon="add-1"
                              [width]="16"
                              [height]="16"
                              color="#ffffff"
                            ></lum-ui-icon>
                          </button>
                        </ng-container>
                        <ng-template #removeWeight>
                          <button
                            class="lum-button lum-button--secondary w-20"
                            mat-icon-button
                            (click)="onRemoveWeight('cartonWeights', idx)"
                          >
                            <lum-ui-icon
                              icon="minus-circle"
                              [width]="16"
                              [height]="16"
                              color="#3a47af"
                            ></lum-ui-icon>
                          </button>
                        </ng-template>
                      </div>
                    </div>
                  </ng-container>
                </div>
              </div>
            </div>
            <div class="form-group">
              <div class="flex align-center gap-4">
                <label class="inline-label">Dimensions (in)</label>
                <div class="flex gap-2">
                  <input
                    type="number"
                    class="lum-input"
                    formControlName="product_length"
                    min="0"
                    placeholder="Length"
                  />
                  <input
                    type="number"
                    class="lum-input"
                    formControlName="product_width"
                    min="0"
                    placeholder="Width"
                  />
                  <input
                    type="number"
                    class="lum-input"
                    formControlName="product_height"
                    min="0"
                    placeholder="Height"
                  />
                </div>
              </div>
            </div>
            <div class="form-group">
              <div class="flex align-center gap-4">
                <label class="inline-label"># of units per carton</label>
                <input
                  type="number"
                  class="lum-input grow-0 w-p40"
                  min="0"
                  formControlName="units_per_carton"
                />
              </div>
            </div>
          </div>
          <div class="col-md-12">
            <div class="font-semi-bold mb-2">Pallet Dimension</div>
            <div class="form-group">
              <div class="flex align-center gap-4">
                <label class="inline-label">Weight</label>
                <div formArrayName="palletWeights">
                  <ng-container
                    *ngFor="
                      let dimension of palletWeightsControl.controls;
                      let idx = index
                    "
                  >
                    <div class="flex gap-2 mb-1" [formGroupName]="idx">
                      <input
                        type="number"
                        class="lum-input grow-0 w-p40"
                        min="0"
                        formControlName="wv"
                      />
                      <mat-select
                        class="lum-select grow-0 w-p40"
                        formControlName="mu"
                      >
                        <mat-option
                          *ngFor="let unit of weightUnits"
                          [value]="unit"
                          >{{ unit }}</mat-option
                        >
                      </mat-select>
                      <div class="grow-0">
                        <ng-container *ngIf="idx === 0; else removeWeight">
                          <button
                            class="lum-button w-20"
                            mat-icon-button
                            (click)="onAddWeight('cartonWeights')"
                          >
                            <lum-ui-icon
                              icon="add-1"
                              [width]="16"
                              [height]="16"
                              color="#ffffff"
                            ></lum-ui-icon>
                          </button>
                        </ng-container>
                        <ng-template #removeWeight>
                          <button
                            class="lum-button lum-button--secondary w-20"
                            mat-icon-button
                            (click)="onRemoveWeight('cartonWeights', idx)"
                          >
                            <lum-ui-icon
                              icon="minus-circle"
                              [width]="16"
                              [height]="16"
                              color="#3a47af"
                            ></lum-ui-icon>
                          </button>
                        </ng-template>
                      </div>
                    </div>
                  </ng-container>
                </div>
              </div>
            </div>
            <div class="form-group">
              <div class="flex align-center gap-4">
                <label class="inline-label">Dimensions (in)</label>
                <input
                  type="number"
                  class="lum-input"
                  formControlName="product_length"
                  min="0"
                  placeholder="Length"
                />
                <input
                  type="number"
                  class="lum-input"
                  formControlName="product_width"
                  min="0"
                  placeholder="Width"
                />
                <input
                  type="number"
                  class="lum-input"
                  formControlName="product_height"
                  min="0"
                  placeholder="Height"
                />
              </div>
            </div>
            <div class="form-group">
              <div class="flex align-center gap-4">
                <label class="inline-label"># of cartons per pallet</label>
                <input
                  type="number"
                  class="lum-input grow-0 w-p40"
                  min="0"
                  formControlName="cartons_per_pallet"
                />
              </div>
            </div>
            <div class="form-group">
              <div class="flex align-center gap-4">
                <label class="inline-label"># of units per pallet</label>
                <input
                  type="number"
                  class="lum-input grow-0 w-p40"
                  min="0"
                  formControlName="units_per_pallet"
                />
              </div>
            </div>
            <div class="form-group">
              <mat-checkbox class="lum-checkbox" formControlName="is_palletized">
                Palletized
              </mat-checkbox>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>
